"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NubbinStyleName = exports.FooterStyleName = exports.BodyStyleName = exports.CloseButtonStyle = exports.TitleBarStyleName = exports.PopoverAlertStyles = exports.PopoverTriggerStyleName = exports.PopoverStyleName = exports.PlacementAttributeName = void 0;
var tslib_1 = require("tslib");
exports.PlacementAttributeName = 'data-popper-placement';
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var TabStyles_1 = require("../../styles/TabStyles");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
var AlertStyles_1 = require("../AlertStyles");
var DialogHeader_1 = require("../Dialog/DialogHeader");
var DialogWidget_1 = require("../Dialog/DialogWidget");
var BorderWidth = DialogWidget_1.DialogBorderWidth;
var MaxBodyHeight = 316;
var PopoverBoxShadow = '0 10px 16px -4px rgba(42, 87, 117, 0.20)';
exports.PopoverStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, DialogWidget_1.getStyles().Dialog), { borderRadius: 2, boxShadow: PopoverBoxShadow, boxSizing: 'border-box', color: TabStyles_1.TabStyles.Typography.Color.Primary, fontSize: TabStyles_1.TabStyles.Typography.Sizing.Default, position: 'absolute', $nest: {
        // add 4px affordance to allow clicking on the scrollbar without causing the popover to close
        '&.titleBarVisible::after': {
            bottom: 0,
            content: "\"\"",
            position: 'absolute',
            right: -4,
            top: 0,
            width: 4,
        },
        '&.darkMode': {
            color: TabStyles_1.TabStyles.Typography.Color.InvertedPrimary,
        }
    } }));
exports.PopoverTriggerStyleName = TypeStyle.style({
    $nest: {
        // By default [aria-haspopup] will add a dropdown arrow to the button. Hide that for our trigger.
        '&[aria-haspopup]::after': {
            display: 'none !important',
        },
    }
});
exports.PopoverAlertStyles = {
    '&.success': { backgroundColor: AlertStyles_1.ColorMap.success.backgroundColor },
    '&.info': { backgroundColor: AlertStyles_1.ColorMap.info.backgroundColor },
    '&.warning': { backgroundColor: AlertStyles_1.ColorMap.warning.backgroundColor },
    '&.error': { backgroundColor: AlertStyles_1.ColorMap.error.backgroundColor },
};
exports.TitleBarStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, DialogHeader_1.getStyles().TitleBar), { height: 40, fontSize: 14, paddingRight: 40, $nest: tslib_1.__assign(tslib_1.__assign({}, exports.PopoverAlertStyles), { '> div': {
            display: 'inline-flex',
        }, '> span': tslib_1.__assign({}, TextEllipsis_1.TextEllipsis) }) }));
exports.CloseButtonStyle = {
    height: 24,
    position: 'absolute',
    right: 8,
    top: 8,
    width: 24,
};
exports.BodyStyleName = TypeStyle.style({
    marginTop: 16,
    marginRight: 40,
    marginBottom: 16,
    maxHeight: MaxBodyHeight,
    overflowY: 'auto',
    paddingRight: 4,
    paddingLeft: 16,
    $nest: {
        '&.titleBarVisible': {
            marginRight: 0,
            marginTop: 0,
            minHeight: 40,
            paddingRight: 16,
            paddingTop: 16,
        },
    },
});
exports.FooterStyleName = TypeStyle.style({
    boxSizing: 'border-box',
    display: 'flex',
    height: 40,
    justifyContent: 'flex-end',
    padding: 16,
    paddingTop: 0,
    $nest: {
        '& button': {
            marginLeft: 16,
        },
    }
});
var NubbinSegmentLength = 14; // ~Math.sqrt(8^2 + 11^2) pythagorean theorem to get segment length
var NubbinStyles = {
    background: 'inherit',
    border: 'inherit',
    boxSizing: 'border-box',
    height: NubbinSegmentLength,
    position: 'absolute',
    width: NubbinSegmentLength,
    zIndex: -1,
};
exports.NubbinStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({ $debugName: 'nubbin' }, NubbinStyles), { visibility: 'hidden', $nest: (_a = {},
        _a["&[" + exports.PlacementAttributeName + "^=\"top\"]"] = {
            borderLeft: 'none',
            borderTop: 'none',
            bottom: -NubbinSegmentLength / 2 - BorderWidth,
        },
        _a["&[" + exports.PlacementAttributeName + "^=\"bottom\"]"] = {
            borderBottom: 'none',
            borderRight: 'none',
            top: -NubbinSegmentLength / 2 - BorderWidth * 2,
        },
        _a["&[" + exports.PlacementAttributeName + "^=\"left\"]"] = {
            borderBottom: 'none',
            borderLeft: 'none',
            right: -NubbinSegmentLength / 2 - BorderWidth,
        },
        _a["&[" + exports.PlacementAttributeName + "^=\"right\"]"] = {
            borderTop: 'none',
            borderRight: 'none',
            left: -NubbinSegmentLength / 2 - BorderWidth * 2,
        },
        _a['&::before'] = tslib_1.__assign(tslib_1.__assign({}, NubbinStyles), { backgroundColor: 'inherit', content: "\"\"", transform: 'rotate(45deg)', visibility: 'visible' }),
        _a['&.hidden::before'] = {
            visibility: 'hidden',
        },
        _a['&.nubbinHasColor'] = {
            backgroundColor: DialogHeader_1.getStyles().TitleBar.backgroundColor,
            $nest: tslib_1.__assign({}, exports.PopoverAlertStyles)
        },
        _a) }));
//# sourceMappingURL=PopoverStyles.js.map